import * as React from 'react';
import classnames from 'classnames';

import type { DiscoveryFiltersTitleSize } from 'types';

import './discovery-filters-title.scss';

type Props = {
  title: string,
  children?: React.ReactNode,
  isDisabled?: boolean,
  size?: DiscoveryFiltersTitleSize
};

const DiscoveryFiltersTitle = (
  {
    title,
    children,
    isDisabled,
    size = 'normal'
  }: Props
): JSX.Element => {
  const titleClasses = classnames(
    'discovery-filters-title__title',
    `discovery-filters-title__title--size-${size}`,
    {
      'discovery-filters-title__title--is-disabled': isDisabled
    }
  );

  const childrenClasses = classnames('discovery-filters-title__children', {
    'discovery-filters-title__children--is-disabled': isDisabled
  });

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <React.Fragment>
      {
        title && (
          <div className="discovery-filters-title">
            <div className={titleClasses}>
              {title}
            </div>
            <div className={childrenClasses}>
              {children}
            </div>
          </div>)
      }
    </React.Fragment>
  );
};

export default DiscoveryFiltersTitle;
